import NAME from "./constants";

export const GET_ASSISTANCE_ROWS = NAME + "/GET_ASSISTANCE_ROWS";
export const GET_ASSISTANCE_ROWS_FULFILLED = NAME + "/GET_ASSISTANCE_ROWS_FULFILLED";
export const GET_ASSISTANCE_ROWS_REJECTED = NAME + "/GET_ASSISTANCE_ROWS_REJECTED";